module.exports = __webpack_public_path__ + "static/media/drive.98b753ae.svg";